import { render } from "./FooBar.vue?vue&type=template&id=cf025684"
import script from "./FooBar.vue?vue&type=script&lang=js"
export * from "./FooBar.vue?vue&type=script&lang=js"

import "./FooBar.vue?vue&type=style&index=0&id=cf025684&lang=scss"
script.render = render

export default script